import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const DashboardKpi = ({
  kpiTitle = "",
  kpiValue = "",
  kpiIcon = "fas fa-chart-bar",
  iconBakgroundColor = "",
  navigateUrl = "#",
  textColor = "text-white",
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Col lg="6" xl="3">
        <Card
          className="card-stats mb-4 mb-xl-0 text-dark"
          style={{ cursor: "pointer", height: "12 0px" }} // Fixed height for all cards
        >
          <CardBody onClick={() => navigate(navigateUrl)}>
            <Row>
              <div className="col">
                <CardTitle
                  className="text-uppercase mb-0"
                  style={{ color: "black", fontSize: "125%", fontWeight: "bold" }}
                >
                  {kpiValue}
                </CardTitle>
                <span
                  className="font-weight-bold mb-0"
                  style={{
                    color: "black",
                    fontSize: "74%",
                    fontWeight: "bold",
                  }}
                >
                  {kpiTitle}
                </span>
              </div>
              <Col className="col-auto">
                <div
                  className={`icon icon-shape ${iconBakgroundColor} ${textColor} rounded-circle shadow`}
                >
                  <i className={kpiIcon} />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default DashboardKpi;
